import { apiRequest } from '../client';

/** Mirrors backend in.voltpassport.metadata.domain.FieldType. Extend when the
 *  server adds new types — and add a renderer in {@code forms/registry.ts}. */
export type FieldType = 'TEXT' | 'NUMBER' | 'BOOLEAN' | 'DATE' | 'ENUM';

export type EntityDefinitionStatus = 'DRAFT' | 'ACTIVE' | 'RETIRED';

export interface EntityDefinitionView {
  id: string;
  code: string;
  name: string;
  definitionVersion: number;
  status: EntityDefinitionStatus;
}

export interface FieldDefinitionView {
  id: string;
  entityDefinitionId: string;
  name: string;
  fieldType: FieldType;
  required: boolean;
  displayOrder: number;
}

export const metadataApi = {
  getEntityDefinition: (id: string) =>
    apiRequest<EntityDefinitionView>(`/api/metadata/entity-definitions/${id}`),

  getActiveByCode: (code: string) =>
    apiRequest<EntityDefinitionView>(`/api/metadata/entity-definitions/by-code/${code}`),

  listFields: (entityDefinitionId: string) =>
    apiRequest<FieldDefinitionView[]>(
      `/api/metadata/entity-definitions/${entityDefinitionId}/fields`
    )
};
